import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
} from '@pf/shared-utility';
import {
    PutAwayListCreate,
    PutAwayListDto,
    PutAwayListRead,
    PutAwayListSearchParams,
} from '../../entities/put-away-list.dto';
import { ResourceAuthSymbol } from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.PutAwayList);

withDefaultEntityMetadata<PutAwayListDto>(symbols.dto, {
    name: String,
    assignedTo: String,
    putAwayByDate: String,
    organizedBy: String,
    status: String,
    putAways: [Object],
    warehouse: Object,
    warehouseId: String,
    equipmentId: String,
    equipment: Object,
    resourceAuth: ResourceAuthSymbol,
});

withDefaultEntityMetadata<PutAwayListRead>(symbols.entity, {
    warehouse: Object,
    assignedTo: String,
    putAwayByDate: String,
    organizedBy: String,
    status: String,
    equipmentId: String,
    equipment: Object,
    putAways: [Object],
    resourceAuth: ResourceAuthSymbol,
});

withMetadata<PutAwayListCreate>(symbols.createBody, {
    warehouseId: String,
    assignedTo: String,
    putAwayByDate: String,
    organizedBy: String,
    status: String,
    resourceAuth: ResourceAuthSymbol,
    equipmentId: String,
});

withDefaultSearchParamsMetadata<PutAwayListSearchParams>(
    symbols.searchParams,
    {}
);

export const PutAwayListMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PutAwayListRead, PutAwayListDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<PutAwayListDto, PutAwayListRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<PutAwayListDto, PutAwayListCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<IQueryParams<PutAwayListDto>, PutAwayListSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
